import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const fdrOverlayWrapper = style({
  display: "flex",
  justifyContent: "center",
  gap: 2,
  margin: "-1px 0",

  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      gap: vars.space["2xs"],
      margin: "-2px 0",
    },
  },
});

const difficultyCellBase = style({
  display: "flex",
  flex: 1,
  justifyContent: "center",
  borderRadius: 2,
  padding: `1px ${vars.space["2xs"]}`,
  maxWidth: 25,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,

  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      padding: `2px 8px`,
      fontSize: vars.fontSizes.body.s,
    },
  },
});

export const difficultyCell = styleVariants({
  1: [difficultyCellBase, vars.colors.difficulties[1]],
  2: [difficultyCellBase, vars.colors.difficulties[2]],
  3: [difficultyCellBase, vars.colors.difficulties[3]],
  4: [difficultyCellBase, vars.colors.difficulties[4]],
  5: [difficultyCellBase, vars.colors.difficulties[5]],
  0: [
    difficultyCellBase,
    {
      color: vars.colors.primaryFixed,
      backgroundColor: vars.colors.surfaceFixed,
    },
  ],
});
